import React, { useEffect, useState, useRef } from 'react';
import useIsMobileDos from '../utilities/function/useIsMobile2';

const Creditos = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchoCreditos, setAnchoCreditos] = useState('');
  const refCreditos = useRef(null);

  const isMobile = useIsMobileDos();
  useEffect(() => {
    if (refCreditos !== null) {
      calcularAncho();
      window.addEventListener('resize', calcularAncho);
      return () => {
        window.removeEventListener('resize', calcularAncho);
      }
    }
  }, [refCreditos, anchoCreditos]);

  const calcularAncho = () => {
    const valorAncho = refCreditos.current.clientWidth;
    setAnchoCreditos(valorAncho);
  }
  return (
    <>
      <div className={`w-screen  absolute top-0 z-1000 alineado-izquierda transition-all duration-500 ${isMobile ? isOpen ? 'right-0' : ' -right-10/12' : isOpen ? 'right-0' : ' -right-11/12' }`}>
        <div className='w-2/12 sm:w-1/12 h-screen  alineado-izquierda z-50'>
          <div

            className=" absolute  flex  bg-no-repeat img-cover-center items-start z-50"
          >
            <div
              className=" w-20 h-44 fondo-creditos-boton flex  mt-20">
              <button
                onClick={() => { setIsOpen(!isOpen) }}
                className=" text-blanco py-20 poppins-700 text-center transform -rotate-90 text-20"
              >
                Créditos
              </button>
            </div>


          </div>
        </div>

        <div
          ref={refCreditos}
          className="w-10/12 sm:w-11/12 h-screen bg-verde rounded-l-22 shadow-1 py-10 px-5 md:pl-14 md:pr-10 "
        >

          <div className={`h-full px-5 grid grid-cols-1 gap-y-4 md:gap-x-10  md:grid-cols-2 scroll-verde `}>

            <div className="text-14 text-blanco"><span className="font-bold">Soy sensible, soy social – Institución Educativa de Promoción Social de Cartagena.</span><br /> (Cartagena, Bolívar)</div>
            <div className="text-14 text-blanco"><span className="font-bold">¿A qué huele el arte de María? –  Institución Educativa para Poblaciones Especiales. </span><br /> (Sincelejo, Sucre)</div>
            <div className="text-14 text-blanco"><span className="font-bold">Efim (Educación Financiera Infantil Marcelinista) – Institución Educativa Distrital Madre Marcelina. </span><br /> (Barranquilla, Atlántico)</div>
            <div className="text-14 text-blanco"><span className="font-bold">Terapias realidad virtual, aumentada y 2D para el manejo de emociones – Institución Educativa Comercial de Envigado.</span><br /> (Envigado, Antioquia)</div>

            <div className="text-14 text-blanco"><span className="font-bold	">Combating Covid – Institución Educativa San José de Itagüí. </span><br />(Itagüí, Antioquia)</div>
            <div className="text-14 text-blanco"><span className="font-bold	">Smartplantic: procesos automatizados – Institución Educativa Distrital El Campito. </span><br />(Barranquilla, Atlántico)</div>
            <div className="text-14 text-blanco"><span className="font-bold	">Empledesempan – Institución Educativa San Rafael. </span><br />(Buenaventura, Valle del Cauca)</div>
            <div className="text-14 text-blanco"><span className="font-bold	">La energía solar y eólica como fuentes energéticas renovables alternativas – Institución Educativa La Herradura.</span><br />(Almaguer, Cauca)</div>

            <div className="text-14 text-blanco"><span className="font-bold	">Escrito por:</span><br />Miguel Castillo Fuentes<br />Pedro José Luis Pulido  </div>
            <div className="text-14 text-blanco"><span className="font-bold	">Ilustrado por:</span><br />Ana Velasco </div>
            <div className="text-14 text-blanco"><span className="font-bold	">Editado por: </span><br />Katerine Amortegui Torres <br />Pedro José Luis Pulido </div>

            <div className="text-14 text-blanco"><span className="font-bold	">Elaborado por: </span><br />Mákina Editorial<br /><a href='https://makinaeditorial.com/' target={'_blank'}>www.makinaeditorial.com</a></div>
            <div className="text-14 text-blanco"><span className="font-bold	">Una publicación de Fundación Terpel </span><br />(2022) </div>

            {/*  <div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>

<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>
<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>
<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>
<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>

<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div>
<div className="text-14 text-blanco"><span className="font-bold	">Combating covid (CC)</span><br />Itagüí - Antioquia</div> */}

          </div>
        </div>
      </div>
      {/*   */}

    </>

  )
}

export default Creditos;